import React from 'react';
import { useState } from 'react';
import useAuth from '../Login/useAuth';
// import bg from '../../img/admin.jpg'
import swal from 'sweetalert';
import AOS from 'aos';
import 'aos/dist/aos.css';
const MakeAdmin = () => {
    const { user } = useAuth()
    const [email, setEmail] = useState('')
    // const [adminSuccess, setadminSuccess] = useState(false)

    const handleOnblur = e => {
        setEmail(e.target.value)
    }
    const handleSubmit = e => {
        const user = { email }
        fetch('https://thawing-ridge-28572.herokuapp.com/emailcollection/admin', {
            method: 'PUT',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(user)
        })
            .then(res => res.json())
            .then(data => {
                if (data.modifiedCount) {
                    swal(' Make ADmin SuccessFulyy')

                }
            }
            )
        e.preventDefault()

    }
    AOS.init();

    return (
        <div className='mt-5 ba p-3'>
            <h3 className='text-start fw-normal text-capitalize text-monoscope'>  hello <em className='text-primary fs-4'> {user.displayName} </em>
      
            </h3>
            <p className='fs-4'>         Admin Page</p>
            <form className='' onSubmit={handleSubmit}>
                <div 
                data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="2500"
                
                className="mb-3 text-start w-50 h-50 mx-auto fs-3">
                    <label for="exampleInputPassword1" className="form-label text-white">Make Admin</label>
                    <input
                        name='email'
                        type="email" className="form-control"
                        onBlur={handleOnblur}
                    />
                    <button type='submit' className='btn btn-dark mt-3'>Submt</button>

                </div>
                {/* {adminSuccess &&
                      swal (' Make ADmin SuccessFulyy')
                   
                } */}
            </form>

        </div>
    );
};

export default MakeAdmin;